function parseGoogleCourse(raw: any) {
  return {
    id: raw._id,
    name: raw.sName,
    enabled: raw.bEnabled,
  };
}

export default parseGoogleCourse;
